import { render, staticRenderFns } from "./DisplayStructured.vue?vue&type=template&id=09feae27&"
import script from "./DisplayStructured.vue?vue&type=script&lang=js&"
export * from "./DisplayStructured.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStructured.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports